import { Snippet } from 'ui/icons/action/Snippet';
import { useModalContext } from 'utils/contexts/modal';
import { BaseToolbarButton } from './BaseToolbarButton';
import { SNIPPET_MODAL_ID } from '../constants';
import { useTranslation } from '../../../../../hooks/useTranslation';

export const ToggleSnippetPickerButton = () => {
  const { showModal } = useModalContext();
  const { t } = useTranslation();

  return (
    <BaseToolbarButton
      isSelected={false}
      onClick={() => showModal(SNIPPET_MODAL_ID)}
      tooltip={t('contentPicker.textEditor.snippet')}
      data-test="snippet-button"
    >
      <Snippet isColorInherited />
    </BaseToolbarButton>
  );
};
